import { extendTheme } from '@chakra-ui/react';
import type { Dict } from '@chakra-ui/utils';

import { Button } from './components/button/button';
import { Checkbox } from './components/checkbox/checkbox';
import { Popover } from './components/popover/popover';
import { Switch } from './components/switch/switch';
import { breakpoints } from './foundations/breakpoints';
import { baseColors } from './foundations/colors/base-colors';
import { strandColors } from './foundations/colors/strand-colors';
import { fonts } from './foundations/fonts';
import { zIndices } from './foundations/z-indices';
import { styles } from './styles/styles';
import { config } from './theme-config';

export const theme: Dict = extendTheme({
    config,
    fonts,
    breakpoints,
    colors: {
        ...baseColors,
        ...strandColors
    },
    zIndices,
    components: {
        Button,
        Switch,
        Checkbox,
        Popover
    },
    styles
});
